import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, } from '@angular/common/http';

import * as global from '../global';
import { AuthService } from 'src/app/services/auth.service';
import {API_URL} from "../../../environments/api-url";
import { UserService } from 'src/app/services/Modules/user.service';



@Injectable({
    providedIn: 'root',
  })
export class NotificationsSettingsService {
    private currentUser:any;

    constructor(private httpclient: HttpClient,
        private _authService: AuthService,
        private _userService:UserService) {
        // const currentUser = localStorage.getItem('currentUser');
        const currentUser = this._authService.currentUser;
        if(currentUser) {
            // this.currentUser = JSON.parse(currentUser);
            this.currentUser = currentUser;
        }
    }

    getUserNotificationsState() {
        const filter = {
            _id: this.currentUser._id
        }
        const projection = {
            email_notification_ids:1,
            text_notification_ids:1,
            push_notification_ids:1,
            allow_two_factor_change_by_admin:1
        };
        return this._userService.getUser(filter, projection).pipe();
    }

    getNotificationOperations() {
        const details = {
            id: this.currentUser._id,
            usertype: this.currentUser.user_type,
            auth_key: this.currentUser.auth_key
        };
        return this.httpclient
            .post(global.url + API_URL.ROUTES.getAllNotificationOperations, {details}).pipe();
    }

    
    updateUserNotifcationSettings(notification_key:string, notification_ids:string[]) {
        const details = {
            id: this.currentUser._id,
            usertype: this.currentUser.user_type,
            auth_key: this.currentUser.auth_key,
            notification_key,
            notification_ids
        };
        return this.httpclient
            .post(global.url + API_URL.AUTH.updateUserNotifcationSettings, {details}).pipe();
    }

    
}
